export const environment = {
  production: false,
  url: "https://api-motor.policystreet.app",
  cleverTapId: "TEST-ZK9-6ZK-696Z",
};
